 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTMLCOVER from '@/components/xhtml/cover'
 import XHTMLABTNYUP_PRESS from '@/components/xhtml/abtnyup_press'
 import XHTMLHALFTITLE from '@/components/xhtml/halftitle'
 import XHTMLTITLE from '@/components/xhtml/title'
 import XHTMLCOPYRIGHT from '@/components/xhtml/copyright'
 import XHTMLDEDI from '@/components/xhtml/dedi'
 import XHTMLCONTENT from '@/components/xhtml/content'
 import XHTMLPREFACE from '@/components/xhtml/Preface'
 import XHTMLCHAPTER1 from '@/components/xhtml/chapter1'
 import XHTMLCHAPTER2 from '@/components/xhtml/chapter2'
 import XHTMLCHAPTER3 from '@/components/xhtml/chapter3'
 import XHTMLCHAPTER4 from '@/components/xhtml/chapter4'
 import XHTMLCHAPTER5 from '@/components/xhtml/chapter5'
 import XHTMLCHAPTER6 from '@/components/xhtml/chapter6'
 import XHTMLCHAPTER7 from '@/components/xhtml/chapter7'
 import XHTMLCHAPTER8 from '@/components/xhtml/chapter8'
 import XHTMLCHAPTER9 from '@/components/xhtml/chapter9'
 import XHTMLCHAPTER10 from '@/components/xhtml/chapter10'
 import XHTMLCHAPTER11 from '@/components/xhtml/chapter11'
 import XHTMLEDITORSNOTE from '@/components/xhtml/Editors-note'
 import XHTMLCONTRIBUTORS from '@/components/xhtml/Contributors'
 import XHTMLINDEX from '@/components/xhtml/Index'
 import XHTMLABOUTTHEEDITOR from '@/components/xhtml/About-the-Editor'
 import XHTMLPREFN1 from '@/components/xhtml/prefn1'
 import XHTMLCH1FN1 from '@/components/xhtml/ch1fn1'
 import XHTMLCH4FN1 from '@/components/xhtml/ch4fn1'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/cover",
 			"name" : "xhtml/cover",
 			"component" : XHTMLCOVER
 		},
 		{
 			"path" : "/xhtml/abtnyup_press",
 			"name" : "xhtml/abtnyup_press",
 			"component" : XHTMLABTNYUP_PRESS
 		},
 		{
 			"path" : "/xhtml/halftitle",
 			"name" : "xhtml/halftitle",
 			"component" : XHTMLHALFTITLE
 		},
 		{
 			"path" : "/xhtml/title",
 			"name" : "xhtml/title",
 			"component" : XHTMLTITLE
 		},
 		{
 			"path" : "/xhtml/copyright",
 			"name" : "xhtml/copyright",
 			"component" : XHTMLCOPYRIGHT
 		},
 		{
 			"path" : "/xhtml/dedi",
 			"name" : "xhtml/dedi",
 			"component" : XHTMLDEDI
 		},
 		{
 			"path" : "/xhtml/content",
 			"name" : "xhtml/content",
 			"component" : XHTMLCONTENT
 		},
 		{
 			"path" : "/xhtml/Preface",
 			"name" : "xhtml/Preface",
 			"component" : XHTMLPREFACE
 		},
 		{
 			"path" : "/xhtml/chapter1",
 			"name" : "xhtml/chapter1",
 			"component" : XHTMLCHAPTER1
 		},
 		{
 			"path" : "/xhtml/chapter2",
 			"name" : "xhtml/chapter2",
 			"component" : XHTMLCHAPTER2
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js